import { render, staticRenderFns } from "./EducationServices.vue?vue&type=template&id=4a3fd9a9"
import script from "./EducationServices.vue?vue&type=script&lang=js"
export * from "./EducationServices.vue?vue&type=script&lang=js"
import style0 from "./EducationServices.vue?vue&type=style&index=0&id=4a3fd9a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports